export default {
  name: 'marking--serialNumberType',
};